import {
    Button,
    FormControlLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from '@mui/material'
import { useTheme } from '@mui/system'
import React from 'react'
import { ContractorDto, ContractorType } from '../../services/api/sharedTypes/Contractor'
import CustomTextField from '../../components/common/CustomTextField'
import CustomContainer from '../../components/common/CustomContainer'
import CheckBoxContainer from '../../components/common/CheckBoxContainer'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'

interface ContractorBasicInformationProps {
    contractor: ContractorDto
    setContractor: (contractor: ContractorDto) => void
}
const ContractorBasicInformation: React.FC<ContractorBasicInformationProps> = ({
    contractor,
    setContractor,
}: ContractorBasicInformationProps) => {
    const theme = useTheme()

    return (
        <CustomContainer bgColor={theme.palette.background.default} disableMarginTop>
            <Grid container rowSpacing={3} columnSpacing={4}>
                <Grid item md={6} xs={12}>
                    <Typography variant='h6' color='primary' mb={2}>
                        Základní údaje
                    </Typography>

                    <Grid container rowSpacing={3} columnSpacing={3}>
                        <Grid item xs={7}>
                            <RadioGroup
                                value={contractor.type}
                                onChange={(e) => setContractor({ ...contractor, type: Number(e.target.value) })}
                                row
                            >
                                <FormControlLabel value={ContractorType.Brigadier} control={<Radio />} label='Brigádník' />
                                <FormControlLabel value={ContractorType.Carrier} control={<Radio />} label='Dopravce' />
                            </RadioGroup>
                        </Grid>

                        <Grid item xs={5}>
                            <CheckBoxContainer checked={contractor.canBeAssigned} label='Nabízet k přidávání události' onClick={() => setContractor({ ...contractor, canBeAssigned: !contractor.canBeAssigned })} />
                        </Grid>

                        <Grid item xs={6} mt={'2px'}>
                            <CustomTextField
                                fullWidth
                                size='small'
                                placeholder='Jméno'
                                label='Jméno'
                                value={contractor.name}
                                onChange={(e) => setContractor({ ...contractor, name: e.target.value })}
                            />
                        </Grid>

                        <Grid item xs={6} mt={'2px'}>
                            <CustomTextField
                                fullWidth
                                size='small'
                                placeholder='Příjmení'
                                label='Příjmení'
                                value={contractor.lastName}
                                onChange={(e) => setContractor({ ...contractor, lastName: e.target.value })}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item md={6} xs={12}>
                    <CustomTextField
                        fullWidth
                        size='small'
                        placeholder='Poznámka'
                        label='Poznámka'
                        value={contractor.note}
                        onChange={(e) => setContractor({ ...contractor, note: e.target.value })}
                    />

                    <Stack direction='row' spacing={3} mt={3}>
                        <Button
                            variant='contained'
                            size='small'
                            onClick={() => setContractor({ ...contractor, emails: [...contractor.emails, ''] })}
                        >
                            + Přidat email
                        </Button>
                        <Button
                            variant='contained'
                            size='small'
                            onClick={() => setContractor({ ...contractor, phones: [...contractor.phones, ''] })}
                        >
                            + Přidat tel. číslo
                        </Button>
                    </Stack>
                    <Grid container>
                        {contractor.emails.map((email, index) => (
                            <Grid key={index} item xs={6}>
                                <Stack direction='row' pt={3} overflow='auto' alignItems='center'>
                                    <CustomTextField
                                        fullWidth
                                        size='small'
                                        placeholder='Email'
                                        label='Email'
                                        onChange={(e) => {
                                            const emails = [...contractor.emails]
                                            emails[index] = e.target.value
                                            setContractor({ ...contractor, emails })
                                        }}
                                        value={email}
                                    />
                                    <IconButton
                                        onClick={() => {
                                            const emails = [...contractor.emails]
                                            emails.splice(index, 1)
                                            setContractor({ ...contractor, emails })
                                        }}
                                        color='error'
                                    >
                                        <DeleteOutlineRoundedIcon />
                                    </IconButton>
                                </Stack>
                            </Grid>
                        ))}
                        {contractor.phones.map((phone, index) => (
                            <Grid key={index} item xs={6}>
                                <Stack direction='row' pt={3} overflow='auto' alignItems='center'>
                                    <CustomTextField
                                        fullWidth
                                        key={index}
                                        size='small'
                                        placeholder='Telefon'
                                        label='Telefon'
                                        type='tel'
                                        onChange={(e) => {
                                            if (isNaN(Number(e.target.value))) return
                                            const phones = [...contractor.phones]
                                            phones[index] = e.target.value
                                            setContractor({ ...contractor, phones })
                                        }}
                                        value={phone}
                                    />
                                    <IconButton
                                        onClick={() => {
                                            const phones = [...contractor.phones]
                                            phones.splice(index, 1)
                                            setContractor({ ...contractor, phones })
                                        }}
                                        color='error'
                                    >
                                        <DeleteOutlineRoundedIcon />
                                    </IconButton>
                                </Stack>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </CustomContainer >
    )
}

export default ContractorBasicInformation
